
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import { type ComCardType, ShowCourse } from '@xt/client/types/home.d'
import ComCard from './card/comCard.vue'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import UserContentPop from '@xt/www/components/classhour/pop-content/index.vue'
import type { DairyOption } from '@xt/client/entities/course-v2/user-content'
import lodash from 'lodash'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'
import { reportEntryLog } from '@xt/client/utils/log'

@Observer
@Component({
  components: {
    NewSwiper,
    LazyImg,
    ComCard,
    UserContentPop
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  @Ref()
  userContentPop: {
    showPop: (options: DairyOption) => void
    hidePop: () => void
  }

  needLogin: boolean = false
  data: ShowCourse[][] = []
  activeIndex: number = 0

  get dataSource() {
    return this.$store.$homeV2.dataSource?.exhibitionCourse
  }

  get loadData() {
    return this.$store.$homeV2.RandomWorks
  }

  @Debounce(200, { leading: true, trailing: false })
  @Bind()
  async handleView(data: { id: number; showId: number; waterUrl: string }) {
    if (!data.id) return

    const momentId = await this.$store.$courseV2.UserContent.worksId2MomentId(data.id)

    if (!momentId) {
      this.$showViewer(data.waterUrl)
      reportEntryLog('work.moment.not-found', { id: data.id, showId: data.showId })
    } else if (this.userContentPop) {
      this.userContentPop.showPop({ type: 'dairy', momentId })
    }
  }

  handleOpenLogin() {
    this.needLogin = true
    this.userContentPop.hidePop()
  }

  handleClosed() {
    if (this.needLogin) {
      this.$store.$storeUser.onToggleVisible(true)
      this.needLogin = false
    }
  }

  handleChange(index: number) {
    this.activeIndex = index
  }

  prev() {
    if (!this.swiper) return

    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return

    this.swiper.handleNext()
  }

  created(): void {
    this.loadData.loadRandomWorks()
  }

  mounted(): void {
    this.data = lodash.chunk(this.dataSource?.list, 4)
  }

  updated(): void {}

  destroyed(): void {}
}
